// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"492":"26d500de","634":"d5750f30","985":"451e3db7"}[chunkId] + ".chunk.css";
};